import { Box, Typography } from '@mui/material';

import { getInitials, getName, useAccount } from 'restful/accounts';

import BorderStack from 'components/@common/BorderStack';

const AccountCard = () => {
  const { account } = useAccount();

  if (!account) return null;

  return (
    <BorderStack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 56,
          minWidth: 56,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textTransform: 'uppercase',
            mb: -0.5,
          }}
        >
          {getInitials(account)}
        </Typography>
      </Box>
      <Box
        sx={{
          gap: '1',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant="h7"
          sx={{
            flexGrow: 1,
          }}
        >
          {getName(account)}
        </Typography>
        <Typography variant="body1">{account.email}</Typography>
      </Box>
    </BorderStack>
  );
};

export default AccountCard;
